import { AlertCircleIcon, RefreshCcwIcon } from 'lucide-react';

import { cn } from '../../utils/cn.js';

import { Button } from '../ui/button';

/**
 * Renders an error message component with customizable options.
 *
 * @param {Object} props - The props for the error component.
 * @param {boolean} [props.pageHeight=false] - Whether to display the error in a page.
 * @param {boolean} [props.showIcon=true] - Whether to display the error icon.
 * @param {number} [props.iconSize=20] - The size of the error icon.
 * @param {string} [props.errorMessage="Ocorreu um erro..."] - The error message to display.
 * @param {boolean} [props.showReloadButton=true] - Whether to display the reload button.
 * @param {string} [props.className]
 *
 * @return {JSX.Element} The error message component
 */
const Error = ({
  pageHeight = false,
  showIcon = true,
  iconSize = 20,
  errorMessage = 'Ocorreu um erro...',
  showReloadButton = true,
  className,
}) => {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center',
        pageHeight && 'min-h-[70vh]',
        className,
      )}
    >
      {showIcon && <AlertCircleIcon className={`size-${iconSize}`} />}
      <h1 className="py-6 text-xl">{errorMessage}</h1>
      {showReloadButton && (
        <Button variant="link" onClick={() => window.location.reload()}>
          <RefreshCcwIcon />
          Recarregar a página
        </Button>
      )}
    </div>
  );
};

export default Error;
